module.exports = __webpack_public_path__ + "img/3.8994e10b.png";